import { render, staticRenderFns } from "./cardTitle.vue?vue&type=template&id=1153b681&"
import script from "./cardTitle.vue?vue&type=script&lang=js&"
export * from "./cardTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports